import React, { useState } from 'react'
import { Carousel, Image } from 'react-bootstrap';
import samplePic from '../../assets/no-image.webp';
import camera from '../../assets/icons8-compact-camera-50.webp';
import { FaBath, FaBed } from 'react-icons/fa';
import { LiaVectorSquareSolid } from 'react-icons/lia';

const PropertyImage = ({listing,setModalShow}) => {
    return (
        <>
            <Image
                src={listing?.Unit.defaultImg || samplePic}
                alt={listing?.Property?.PropertyUnitTypeTitle
                    ? `${listing.Property.PropertyUnitTypeTitle} - ${listing.Unit.Address.City}, ${listing.Unit.Address.PostalCode} | ${listing.Unit.UnitBedrooms} Bedroom Apartment for Rent`
                    : "Apartment for Rent - Spacious Rental Unit"}
                className="image-container mb-4 mb-lg-0"
                fluid
            />
            {listing?.Unit?.Features?.length > 0 && (
                <button onClick={() => setModalShow(true)} className="seePhotoBtn">
                <img className="p-1" src={camera}
                    alt={`See all photos of ${listing?.Property?.PropertyUnitTypeTitle} at ${listing?.Unit?.Address?.City.trim()}, ${listing?.Unit?.Address?.PostalCode.trim()}`}
                    width={30} />

                See all photos
            </button>
            )}
            <div className='w-100 Pdetails py-4 d-flex justify-content-around'>
                <div>
                    <FaBed title='Bedrooms' size={20} className="icon-primary" />
                    <span>{" " + listing?.Unit?.UnitBedrooms || 'N/A'}</span>
                </div>
                <div className='d-flex gap-2 align-items-center'>
                    <FaBath title='Bathrooms' size={20} className="icon-primary" />
                    <span>{" " + listing?.Unit?.UnitBathrooms || 'N/A'}</span>
                </div>
                <div>
                    <LiaVectorSquareSolid title='Sq Ft' size={20} className="icon-primary" />
                    <span>{" " + (listing?.Unit?.UnitSize !== 0 ? listing?.Unit?.UnitSize : 'N/A')}</span>
                </div>
            </div>
        </>
    )
}

export default PropertyImage


export const SlidePreviewImage = ({ listing }) => {
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };
    return (
        <div className="mt-4">
            <Carousel data-bs-theme="dark" activeIndex={index} onSelect={handleSelect} fade className='w-100 h-100'>
                {listing?.Unit?.Files?.map((img, index) => (
                    <Carousel.Item key={index}>
                        <Image src={img.Url} alt={`Image ${index + 1} of ${listing?.Property?.Name} - ${listing?.Property?.PropertyUnitTypeTitle || "Property"} in ${listing?.Unit?.Address?.AddressLine1 || "Unknown Location"}`} className="image-containers mb-4 mb-lg-0" fluid />
                    </Carousel.Item>
                ))}
            </Carousel>
        </div>
    )
}


